module.exports = __webpack_public_path__ + "media/images/light_grey_background-c05f9b889d93e5bcc5982268eafd471e.png";